<app-header></app-header>
<ion-content class="customContainer">
  <ion-grid class="subHeader">
    <ion-row class="ion-justify-content-start ion-align-items-center">
      <ion-col size="12" size-sm="4" size-lg="12">
        <ion-toolbar mode="md">
          <!-- <ion-buttons slot="start" class="ion-no-margin">
            <ion-back-button slot="start" color="primary" defaultHref="/home" text=""
              icon="chevron-back-outline"></ion-back-button>
          </ion-buttons> -->
          <ion-buttons slot="start">
            <ion-back-button defaultHref="/home"></ion-back-button>
          </ion-buttons>
          <ion-title>{{categoryId | language : categoryId}} {{'shops' | language : "Shops"}}</ion-title>
        </ion-toolbar>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ng-container>
    <ion-progress-bar mode="ios" color="primary" type="indeterminate"
      *ngIf="commonservice.isLoading"></ion-progress-bar>
    <div *ngFor="let item of filtermerchantListArray" class="main">
      <app-store-listing [item]="item" (favEvent)="favouriteShop($event)"></app-store-listing>
    </div>
  </ng-container>
</ion-content>